import { RouteObject } from 'react-router-dom';
import {
  UserCompletedRegisterPage,
  UserDetailsPage,
  UserPersonalDetailsPage,
  UserRegisterPage,
} from './lazy';

const USER_ROOT = '/profile';

export const USER_ROUTES = {
  userDetails: `${USER_ROOT}/details`,
  userPersonalDetails: `${USER_ROOT}/personal-details`,
  userSecurityIssue: `${USER_ROOT}/security-issue`,
  userPassword: `${USER_ROOT}/password`,
  register: '/public/register',
  completedRegister: '/public/completed-register',
};

export const userProfileRouteObject: RouteObject = {
  path: USER_ROOT,
  children: [
    {
      path: USER_ROUTES.userDetails,
      element: <UserDetailsPage />,
    },
    {
      path: USER_ROUTES.userPersonalDetails,
      element: <UserPersonalDetailsPage />,
    },
  ],
};

export const publicUserRouteObject: RouteObject = {
  path: '/public',
  children: [
    {
      path: USER_ROUTES.register,
      element: <UserRegisterPage />,
    },
    {
      path: USER_ROUTES.completedRegister,
      element: <UserCompletedRegisterPage />,
    },
  ],
};
